import { useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import CollapsibleRow from '../components/CollapsibleRow';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';
import ConversionTimeTableRow from './ConversionTimeTableRow';

export default function ConversionTimeGroupedTableContent({ headers }) {
  const { conversionTime } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );

  return (
    <Table.Rows>
      {conversionTime.branches.map((branch) => {
        const items = [
          `${branch.branch.name} (${branch.agents?.length})`,
          branch.conversion_rate,
          branch.assigned_contacts,
          branch.with_visits,
          branch.with_reservations,
          branch.concreted,
          branch.lost,
          branch.in_progress,
        ];

        return (
          <CollapsibleRow key={branch.branch_id} items={items}>
            {branch?.agents?.map((agent, index) => (
              // eslint-disable-next-line
              <ConversionTimeTableRow key={index} row={agent} />
            ))}
          </CollapsibleRow>
        );
      })}

      {conversionTime.loading && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
